import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const Legend = ({spill_over, occupied,hold,total}) => {
  const [loading, setLoading] = useState(false);

  const data = [
    { name: "Spill Over", value: Math.max(0, spill_over ?? 0), color: "#00b0c4" },
    { name: "Occupied", value: Math.max(0, occupied ?? 0), color: "#8f51dd" },
    { name: "Hold Cargo", value: Math.max(0, hold??0), color: "#dd5187" },
    { name: "Available", value: Math.max(0, (total-occupied-hold-spill_over) ?? 0), color: "#ccc" },
  ];
  

  return (
    <div
      className="position-fixed bottom-0 start-0 bg-white px-3 py-2 shadow rounded mb-3 me-0 ms-5"
      style={{ zIndex: 1050, width: "270px" }}
    >
      <h6 className="fw-bold mt-0 mb-2">Legend</h6>
      {loading ? (
        <p>Loading...</p>
      ) : (
        data.map((item, index) => {
          const percent = total > 0 ? ((item.value / total) * 100).toFixed(1) : "0";
          return (
            <div key={index} className="d-flex align-items-center mb-2">
              <span
                className="me-2 d-inline-block rounded"
                style={{
                  width: "15px",
                  height: "15px",
                  backgroundColor: item.color,
                }}
              ></span>
              <span className="">
              {item.name}: {item.value}SQM{"  "}({percent}%)
              </span>
            </div>
          );
        })
      )}

      <div className="d-flex gap-2 align-items-center mt-2">
        <span>Total Area:</span>
        <span className="text-dark fw-semibold">{total} SQM</span>
      </div>
    </div>
  );
};

export default Legend;
